export default "__VITE_ASSET__$HTJr0VT__";